import React from 'react';
import Header from './Componenets/Header';
import Home from './Pages/Home';
import Footer from './Componenets/Footer';
import Contact from './Pages/Contact';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Products from './Pages/Products';
import PerforatedSheets from './Pages/PerforatedSheets';
import PressComponents from './Pages/PressComponents';
import FuelStrainers from './Pages/FuelStrainers';
import SpotWelding from './Pages/SpotWelding';

import Gallery from './Pages/Gallery'
import About from './Pages/About'
import Whatsapp from './Componenets/Whatsapp';
import Topscroll from './Componenets/Topscroll';
import ThankYou from './Pages/ThankYou';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/product" element={<Products />} />
        <Route path="/PerforatedSheets" element={<PerforatedSheets />} />
        <Route path="/PressComponents" element={<PressComponents />} />
        <Route path="/FuelStrainers" element={<FuelStrainers />} />
        <Route path="/SpotWelding" element={<SpotWelding/>} />
        <Route path="/thankyou" element={<ThankYou />} />

      </Routes>
      <Footer />
      <Whatsapp />
      <Topscroll />
    </Router>
  );
}

export default App;
